import { Button, Container, Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { styled } from '@mui/material/styles';

const CenteredLabelTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputLabel-root': {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    transition: 'all 0.2s ease',
    pointerEvents: 'none',
  },
  '& .MuiInputLabel-shrink': {
    left: 14, top:14,
    transform: 'translate(0, -1.5rem) scale(0.75)', // Comportement normal
  },
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    // Pour Firefox
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
}));


export default function SoutienForm() {
    const [montant, setMontant] = React.useState(0);
    const [openMontant, setOpenMontant] = React.useState(0);

    function handleMontantChange(value) {
        setMontant(value);
        setOpenMontant(0);
    }

    return <Container maxWidth="sm" sx={{ display:'flex', flexDirection:'column', mt: 4, minWidth: '400px' }}>
        
        <Typography variant="h4" align="center" sx={{ mb: 2 }}>Je participe à hauteur de</Typography>

        <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid size={{xs:12, sm:6}}>
                <Button variant={montant===50 ? "contained":"outlined"} fullWidth size="large" color="primary" onClick={() => handleMontantChange(50)}>50€</Button>
            </Grid>
            <Grid size={{xs:12, sm:6}}>
                <Button variant={montant===100 ? "contained":"outlined"} fullWidth size="large" color="primary" onClick={() => handleMontantChange(100)}>100€</Button>
            </Grid>
            <Grid size={{xs:12, sm:6}}>
                <Button variant={montant===250 ? "contained":"outlined"} fullWidth size="large" color="primary" onClick={() => handleMontantChange(250)}>250€</Button>
            </Grid>
            <Grid size={{xs:12, sm:6}}>
                <Button variant={montant===500 ? "contained":"outlined"} fullWidth size="large" color="primary" onClick={() => handleMontantChange(500)}>500€</Button>
            </Grid>
        </Grid>

        <CenteredLabelTextField fullWidth type="number" label="Montant libre" variant="outlined" value={openMontant===0?'':openMontant} 
        slotProps={{inputLabel:{shrink: !!openMontant||openMontant===''}}} onFocus={()=>{if(openMontant===0) setOpenMontant('')}} onBlur={()=>{if(openMontant==='') setOpenMontant(0)}}
        onChange={(e) => {setOpenMontant(e.target.value); setMontant(0)}} sx={{ mb:4 }} />

    </Container>
}